import { useTranslation } from 'react-i18next';

import type { Board } from '@/entities/board';
import { FromTemplateButton } from '@/features/template-manage';
import { Dialog } from '@/shared/ui';

import { CreateBoardForm } from './CreateBoardForm';

/** "New board": a compact dialog instead of a permanently visible form on the workspace page. */
export function CreateBoardDialog({
  workspaceId,
  sectionId,
  groupId,
  onCreated,
  onClose,
}: {
  workspaceId: string;
  sectionId?: string | null | undefined;
  groupId?: string | null | undefined;
  onCreated: (board: Board) => void;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog title={t('boards.createTitle')} size="lg" onClose={onClose}>
      <FromTemplateButton<Board>
        kind="board"
        workspaceId={workspaceId}
        sectionId={sectionId}
        groupId={groupId}
        onCreated={onCreated}
      />
      <CreateBoardForm
        workspaceId={workspaceId}
        sectionId={sectionId}
        groupId={groupId}
        onCreated={onCreated}
        onCancel={onClose}
      />
    </Dialog>
  );
}
